import { render, staticRenderFns } from "./SnackbarBottom.vue?vue&type=template&id=8c7c8876&scoped=true"
import script from "./SnackbarBottom.vue?vue&type=script&lang=ts"
export * from "./SnackbarBottom.vue?vue&type=script&lang=ts"
import style0 from "./SnackbarBottom.vue?vue&type=style&index=0&id=8c7c8876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7c8876",
  null
  
)

export default component.exports